import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchEventTicketSales(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/ticket_sales`,
          qs: { event: event },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventBucketSales(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/sales`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventBucketOverview(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/overview`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassBucketsOverview(
    apiKey, eventBucket, filterState, startDate, endDate, allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `charts/pass_sales`,
          qs: {
            event_bucket: eventBucket,
            filter_state: filterState,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime,
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchPassSalesAnalytics(
    apiKey,
    eventBucket,
    isMembership = false,
    filterState,
    startDate,
    endDate,
    allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/pass_sales`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            filter_state: filterState,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAttendeeAnalytics(
    apiKey, eventBucket, filterState, startDate, endDate, allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/attendees`,
          qs: {
            event_bucket: eventBucket,
            filter_state: filterState,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime,
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchGeoAnalytics(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/geo`,
          qs: { event_bucket: eventBucket },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventSalesAnalytics(apiKey, eventBucket, startDate, endDate, allTime) {

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales_by_event`,
          qs: {
            event_bucket: eventBucket,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventSalesDetailAnalytics(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales_detail_by_event`,
          qs: { event: event },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventPassesAnalytics(apiKey, eventBucket, isMembership, startDate, endDate, allTime) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/passes_by_event`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime,
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchSalesAnalytics(apiKey, options) {

    // all_time needs to be its own parameter in order to trigger 
    // slow responses precompute caching
    const allTime = options.all_time
    let processedOptions = { ...options }

    processedOptions.all_time = undefined

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/sales`,
          qs: { conditions: JSON.stringify(processedOptions), all_time: allTime },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchEventTicketAnalytics(
    apiKey, eventBucketId, filter2State, startDate, endDate, allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/tickets_by_event`,
          qs: {
            event_bucket: eventBucketId,
            filter2_state: filter2State,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime,
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchRecurringPassAnalytics(
    apiKey,
    eventBucket,
    isMembership = false,
    startDate,
    endDate,
    allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/upcoming`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchExpiredPassAnalytics(
    apiKey,
    eventBucket,
    isMembership = false,
    startDate,
    endDate,
    allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/expired_passes`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchNewSubscriptionAnalytics(
    apiKey,
    eventBucket,
    isMembership = false,
    startDate,
    endDate,
    allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/new_subscriptions`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchRecurringPassOverview(
    apiKey,
    eventBucket,
    isMembership = false,
    startDate,
    endDate,
    allTime
  ) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `analytics/recurring_pass/overview`,
          qs: {
            event_bucket: eventBucket,
            is_membership: isMembership,
            start_date: startDate,
            end_date: endDate,
            all_time: allTime
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

};


// WEBPACK FOOTER //
// ./src/app/utils/AnalyticsUtil.js